const validateEmail = value => {
    const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w+)+$/;

    return regex.test(value);
}

const validateNumber = value => {
    const regex = /^[-+]?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?(?:[eE][-+]?\d+)?$/;

    return regex.test(value);
}

const validateDomain = value => {
    const regex = /^(?:(?:[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]\.)+[a-zA-Z]{2,63}|(?:localhost))$/;

    return regex.test(value);
}

export {
    validateEmail,
    validateNumber,
    validateDomain
}